<template>
  <div style="margin: 16px; display: flex; justify-content: center;">
    <el-card
      shadow="hover"
      style="width: 100%; max-width: 60em;"
    >
    <div slot="header" class="clearfix">
    <span>About</span>
  </div>
      <h4>Nexus {{version}}</h4>
      <h6>Credits</h6>
      <ul>
        <li> Christopher Tran</li>
        <li> Nathaniel Heitsch</li>
      </ul>
      <h6>Licenses</h6>
      <ul>
        <li>
          <a href="https://github.com/ElemeFE/element/blob/dev/LICENSE">
            Element UI - MIT License
          </a>
        </li>
        <li>
          <a href="https://github.com/vuejs/vue/blob/dev/LICENSE">
            Vue JS - MIT License
          </a>
        </li>
        <li>
          <a href="https://github.com/vuejs/vuex/blob/dev/LICENSE">
            Vuex - MIT License
          </a>
        </li>
        <li>
          <a href="https://github.com/mholt/PapaParse/blob/master/LICENSE">
            PapaParse - MIT License
          </a>
        </li>
        <li>
          <a href="https://github.com/SSENSE/vue-carousel/blob/master/LICENSE.md">
            Vue Carousel - MIT License
          </a>
        </li>
        <li>
          <a href="https://github.com/AlexandreBonaventure/vue-mq/blob/master/LICENSE">
            Vue MQ - MIT License
          </a>
        </li>
        <li>
          <a href="https://github.com/vuetifyjs/vuetify/blob/dev/LICENSE">
            Vuetify - MIT License
          </a>
        </li>
        <li>
          <a href="https://github.com/mholt/PapaParse/blob/master/LICENSE">
            Vue2 Editor - MIT License
          </a>
        </li>
      </ul>
  </el-card>
  </div>
</template>

<script>
export default {
    data() {
        return {version: ''};
    },
    mounted() {
        this.getVersion();
    },
    methods: {
        getVersion() {
            this.axios
                .get("/api/v1/version", {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.version = response.data.version;
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        showClose: true,
                        message: "Unable to retreive version number.",
                        type: "error"
                    });
                });
        }
    }

}
</script>
